export function initLogosSliderAnim(options = {}) {
	const { sliderSelector = "#slider-logos", innerSelector = ".carousel-inner", animClass = "animation", loadingClass = "load", delay = 0 } = options;

	const slider = document.querySelector(sliderSelector);
	if (!slider) return;

	const inner = slider.querySelector(innerSelector);
	if (!inner) return;

	function start() {
		slider.classList.remove(loadingClass);
		inner.classList.add(animClass);
	}

	let timerId = null;

	if (delay > 0) {
		timerId = setTimeout(start, delay);
	} else {
		start();
	}

	return () => {
		if (timerId !== null) clearTimeout(timerId);
	};
}
